(function () {
  function formatUSPhone(value) {
    // Strip everything except digits
    var digits = value.replace(/\D/g, '');

    // Limit to 10 digits
    if (digits.length > 10) digits = digits.slice(0, 10);

    if (digits.length === 0) return '';
    if (digits.length <= 3) return '(' + digits;
    if (digits.length <= 6) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
    return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
  }

  function onInput(event) {
    var input = event.target;
    var formatted = formatUSPhone(input.value);
    input.value = formatted;
  }

  function initPhoneInputs() {
    document.querySelectorAll('[data-phone-format]').forEach(function (input) {
      input.removeEventListener('input', onInput);
      input.addEventListener('input', onInput);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPhoneInputs);
  } else {
    initPhoneInputs();
  }
})();
